import { Button } from "@mui/material";
import { styled } from "@mui/system";

export const GradientButton = styled(Button)(({ theme }) => ({
  background: "linear-gradient(90deg, #00BB9F, #B0EE93)",
  height: 40,
  fontSize: 16,
  color: "#fff",
  padding: "10px 20px",
  borderRadius: 12,
  transition: "background 0.3s ease-in-out", // Specify the transition property

  "&:hover": {
    background: "linear-gradient(90deg, #B0EE93, #00BB9F)",
  },
}));

export const GradientButtonOutline = styled(Button)(({ theme }) => ({
  background: "transparent",
  border: "2px solid #00BB9F",
  height: 40,
  fontSize: 16,
  color: "#00BB9F",
  padding: "10px 20px",
  borderRadius: 12,
}));

export const GradientOutline = styled(Button)(({ theme }) => ({
  background: "#fff",
  border: "2px solid #ddd",
  height: 40,
  fontSize: 16,
  color: "#ddd",
  padding: "10px 20px",
  borderRadius: 12,
}));

export const GradientShadow = styled(Button)(({ isActive }) => ({
  backgroundColor: isActive ? "#00BB9F" : "#fff",
  border: `2px solid ${isActive ? "#00BB9F" : "#ddd"}`,
  height: 60,
  fontSize: 16,
  color: isActive ? "#fff" : "#ddd",
  padding: "10px 20px",
  borderRadius: 12,
  boxShadow: isActive ? "0px 4px 10px rgba(0, 0, 0, 0.2)" : "none",
  pointerEvents: isActive ? "none" : "auto",
  // transition: "background 0.3s ease, border-color 0.3s ease",

  // Hover effect only when the button is not active
  "&:hover": {
    color: isActive ? "#f5f5f5" : "#00BB9F", // Light grey on hover for inactive buttons
    backgroundColor: isActive ? "#00BB9F" : "#f5f5f5", // Light grey on hover for inactive buttons
    borderColor: isActive ? "#00BB9F" : "#00BB9F", // Change border color on hover for inactive buttons
  },
}));
